import { ApolloLink } from "@apollo/client";
import { useSyncExternalStore } from "react";

// Tracks when station data was last received successfully, so the UI can show
// how fresh the numbers are however the refresh was triggered.
let lastUpdated: number | null = null;
const listeners = new Set<() => void>();

export const markUpdated = (time = Date.now()) => {
    lastUpdated = time;
    listeners.forEach((listener) => listener());
};

export const resetLastUpdated = () => {
    lastUpdated = null;
    listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const useLastUpdated = () =>
    useSyncExternalStore(subscribe, () => lastUpdated);

export const lastUpdatedLink = (operationName: string) =>
    new ApolloLink((operation, forward) =>
        forward(operation).map((result) => {
            if (operation.operationName === operationName && !result.errors) {
                markUpdated();
            }
            return result;
        })
    );
